import { Pipe, PipeTransform } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { selectPrintFramesInBasket } from '@ui/products/shopping-cart-back/actions/selector';
import { map } from 'rxjs/operators';

@Pipe({
    name: 'printFramePrice',
    standalone: false
})
export class PrintFramePricePipe implements PipeTransform {
  constructor(private store: Store) {}

  transform(printFrameId: string, photoId: string) {
    return this.store.pipe(
      select(selectPrintFramesInBasket),
      map((printFramesInBasket) => {
        const printFrame = printFramesInBasket.find(
          (printFrameInBasket) =>
            printFrameInBasket.printFrameId === printFrameId &&
            printFrameInBasket.photoId === photoId
        );
        return printFrame?.price.map(({ price, code }) => ({
          price: price * printFrame.count,
          code,
        }));
      })
    );
  }
}
